import { render, staticRenderFns } from "./CreateGrade.vue?vue&type=template&id=4d42eb8c&"
import script from "./CreateGrade.vue?vue&type=script&lang=js&"
export * from "./CreateGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports